import { render, staticRenderFns } from "./quickBuy.vue?vue&type=template&id=749a0c2a&scoped=true&"
import script from "./quickBuy.vue?vue&type=script&lang=js&"
export * from "./quickBuy.vue?vue&type=script&lang=js&"
import style0 from "./quickBuy.vue?vue&type=style&index=0&id=749a0c2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749a0c2a",
  null
  
)

component.options.__file = "quickBuy.vue"
export default component.exports